import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';

export default function NotFound() {
  useEffect(() => {
    document.title = 'Seite nicht gefunden | Felix Genuss';
  }, []);

  return (
    <>
      <Seo
        title="Seite nicht gefunden | Felix Genuss"
        description="Diese Seite existiert leider nicht. Zurück zur Startseite oder direkt zu den Rezepten von Felix Genuss."
        path="/404"
      />
      <div className="container-site flex flex-col items-start py-20 sm:py-28" data-testid="not-found-page">
        <img
          src="/assets/brand/logo-256.webp"
          alt=""
          width="256"
          height="256"
          loading="lazy"
          className="w-32 sm:w-40"
        />
        <p className="eyebrow mt-8">Fehler 404</p>
        <h1 className="mt-3 font-serif text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">
          Felix findet diese Seite leider nicht.
        </h1>
        <p className="mt-5 max-w-xl leading-relaxed text-brand-brown/85">
          Vielleicht hat sich hier ein Leckerbissen versteckt. Zurück zur Startseite oder direkt zu unseren Rezepten.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link to="/" className="btn-primary" data-testid="notfound-cta-home">Zur Startseite</Link>
          <Link to="/rezepte" className="btn-secondary" data-testid="notfound-cta-rezepte">Zu den Rezepten</Link>
        </div>
      </div>
    </>
  );
}
